__turbopack_context__.v({
  "className": "nunito_sans_3b763021-module__Yci_AW__className",
});
